var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBreadcrumb',{attrs:{"items":_vm.breadcrumb_items}}),_c('StudentGradeTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }